var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPasswordIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.881,
    height: 27.88,
    viewBox: "0 0 27.881 27.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.185,
    cy: 1.185,
    r: 1.185,
    transform: "translate(17.258 17.732)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M12.96,25.7h-8.6a2.181,2.181,0,0,1-2.178-2.178v-8.93a2.181,2.181,0,0,1,2.178-2.178H20.039a2.181,2.181,0,0,1,2.178,2.178v2.178a1.089,1.089,0,1,0,2.178,0V14.595a4.361,4.361,0,0,0-4.356-4.356H18.73V6.4A6.474,6.474,0,0,0,12.2,0,6.474,6.474,0,0,0,5.661,6.4v3.841h-1.3A4.361,4.361,0,0,0,0,14.595v8.93a4.361,4.361,0,0,0,4.356,4.356h8.6a1.089,1.089,0,1,0,0-2.178ZM7.839,6.4A4.294,4.294,0,0,1,12.2,2.179,4.294,4.294,0,0,1,16.552,6.4v3.841H7.839V6.4Z",
    transform: "translate(0 -0.001)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M276.142,322.2a1.089,1.089,0,0,0-1.519.252l-5.368,7.5a.622.622,0,0,1-.9.047l-3.469-3.385a1.089,1.089,0,1,0-1.521,1.559l3.475,3.391.01.009a2.808,2.808,0,0,0,1.932.772q.092,0,.185-.006a2.808,2.808,0,0,0,2-1.04l.037-.048,5.39-7.529A1.089,1.089,0,0,0,276.142,322.2Z",
    transform: "translate(-248.717 -304.465)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.185,
    cy: 1.185,
    r: 1.185,
    transform: "translate(12.992 17.732)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.185,
    cy: 1.185,
    r: 1.185,
    transform: "translate(8.992 17.732)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.185,
    cy: 1.185,
    r: 1.185,
    transform: "translate(4.934 17.732)",
    fill: "#848484"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPasswordIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/passwordIcon.e2f7b1c3.svg";
export { ForwardRef as ReactComponent };